import {
  Zap, Heart, Volume2, GitBranch, ShieldAlert, Compass
} from 'lucide-react';

export const LEADERSHIP_SECTIONS = [
  {
    id: "leadership",
    title: "Leadership",
    icon: Zap,
    category: "leadership",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No leadership roles listed yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 45,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: true,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["student", "all"],
    badges: ["Recommended"],
    fields: [
      { name: "role", label: "Role / Position", type: "text", required: true, placeholder: "e.g. Lead Organizer" },
      { name: "organization", label: "Organization / Venue", type: "text", required: true, placeholder: "e.g. TEDxStanford" },
      { name: "duration", label: "Duration / Dates", type: "text", required: false, placeholder: "e.g. 2023 - 2024" },
      { name: "description", label: "Responsibilities & Achievements", type: "textarea", required: false, placeholder: "Managed budget and coordinated speaker panels..." }
    ],
    defaultData: { role: "", organization: "", duration: "", description: "" }
  },
  {
    id: "volunteer",
    title: "Volunteer Work",
    icon: Heart,
    category: "leadership",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No volunteer work listed yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 40,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: true,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["all"],
    badges: [],
    fields: [
      { name: "role", label: "Volunteer Role", type: "text", required: true, placeholder: "e.g. Literacy Tutor" },
      { name: "organization", label: "Charity / NGO", type: "text", required: true, placeholder: "e.g. Red Cross" },
      { name: "duration", label: "Duration / Dates", type: "text", required: false, placeholder: "e.g. 2022 - 2023" },
      { name: "description", label: "Contributions", type: "textarea", required: false, placeholder: "Assisted in local community drives..." }
    ],
    defaultData: { role: "", organization: "", duration: "", description: "" }
  },
  {
    id: "speaking",
    title: "Speaking Engagements",
    icon: Volume2,
    category: "leadership",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No speaking engagements added yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 35,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: true,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["academic", "all"],
    badges: [],
    fields: [
      { name: "title", label: "Talk / Presentation Title", type: "text", required: true, placeholder: "e.g. Scaling APIs in Serverless Land" },
      { name: "event", label: "Conference / Event", type: "text", required: true, placeholder: "e.g. PyCon 2024" },
      { name: "date", label: "Date", type: "text", required: false, placeholder: "e.g. May 2024" },
      { name: "description", label: "Summary", type: "textarea", required: false, placeholder: "Spoke to 300+ attendees on database clusters..." }
    ],
    defaultData: { title: "", event: "", date: "", description: "" }
  },
  {
    id: "open_source",
    title: "Open Source",
    icon: GitBranch,
    category: "leadership",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No open source contributions listed yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 30,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: true,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["software"],
    badges: ["Recommended"],
    fields: [
      { name: "title", label: "Contribution / Project", type: "text", required: true, placeholder: "e.g. Core Contributor" },
      { name: "repository", label: "Repository / Organization", type: "text", required: true, placeholder: "e.g. facebook/react" },
      { name: "description", label: "Details", type: "textarea", required: false, placeholder: "Fixed memoization edge cases in hook renderers..." }
    ],
    defaultData: { title: "", repository: "", description: "" }
  },
  {
    id: "military",
    title: "Military Service",
    icon: ShieldAlert,
    category: "leadership",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No military service listed yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 25,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: true,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["all"],
    badges: [],
    fields: [
      { name: "rank", label: "Rank / Specialty", type: "text", required: true, placeholder: "e.g. Sergeant" },
      { name: "branch", label: "Branch of Service", type: "text", required: true, placeholder: "e.g. US Army" },
      { name: "duration", label: "Duration / Dates", type: "text", required: false, placeholder: "e.g. 2018 - 2021" },
      { name: "description", label: "Duties / Awards", type: "textarea", required: false, placeholder: "Led platoon of 40 soldiers in tactical operations..." }
    ],
    defaultData: { rank: "", branch: "", duration: "", description: "" }
  },
  {
    id: "extracurricular",
    title: "Extracurriculars",
    icon: Compass,
    category: "leadership",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No extracurricular activities listed yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 20,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: true,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["student"],
    badges: [],
    fields: [
      { name: "role", label: "Position / Role", type: "text", required: true, placeholder: "e.g. Captain" },
      { name: "organization", label: "Club / Sport", type: "text", required: true, placeholder: "e.g. University Chess Club" },
      { name: "duration", label: "Duration / Dates", type: "text", required: false, placeholder: "e.g. 2021 - 2024" },
      { name: "description", label: "Description", type: "textarea", required: false, placeholder: "Won state collegiate chess championship..." }
    ],
    defaultData: { role: "", organization: "", duration: "", description: "" }
  }
];
